import React, { FC, useMemo, useState } from 'react'
import { ISimplifiedVisualMaterial } from '@libs/api'
import { DEFAULT_IMG_SOURCE } from '../MaterialItem'
import { CarouselModal } from '@libs/components'
import { CarouselModalSlideType } from '@libs/components/build/Modals/CarouselModal/types'

import Styled from './Styled'
import { VideoLinksDropdown } from '../VideoLinksDropdown'

export interface MaterialCarouselModalProps {
	visualMaterials: ISimplifiedVisualMaterial[]
	initialMaterialId: ISimplifiedVisualMaterial['id']
}

const { Slide } = CarouselModal

const MaterialCarouselModal: FC<MaterialCarouselModalProps> = ({ visualMaterials, initialMaterialId }) => {
	const [current, setCurrent] = useState(() => visualMaterials.findIndex(({ id }) => id === initialMaterialId))

	const footerContent = useMemo(() => {
		const currentMaterial = visualMaterials[current]
		if (currentMaterial?.links.length > 0 && currentMaterial.type === 'Video') {
			return <VideoLinksDropdown size="middle" links={currentMaterial.links} />
		}
		return null
	}, [current, visualMaterials])

	return (
		<Styled.Modal current={current} onChange={setCurrent} footer={footerContent}>
			{visualMaterials.map(({ source, sourceType }, index) => {
				// pre-render only current, previous and next
				if ((current >= index - 1 && current <= index + 1) || (current === 0 && index === visualMaterials.length - 1)) {
					return (
						<Slide
							key={index}
							type={sourceType.toLowerCase() as CarouselModalSlideType}
							source={source || DEFAULT_IMG_SOURCE}
							fallbackImageSource={DEFAULT_IMG_SOURCE}
						/>
					)
				}
				return <div key={index} />
			})}
		</Styled.Modal>
	)
}

export default MaterialCarouselModal
